import { __esmMin as e } from "../../_virtual/_rolldown/runtime.es.js";
// libs/ui-lib/src/assets/icons/aqlBranchIcon.svg?raw
var t, n = e((() => {
	t = "<svg width=\"18\" height=\"17\" viewBox=\"0 0 18 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M6.90866 11.7583L3.65033 8.5L6.90866 5.24167L5.91699 4.25L1.66699 8.5L5.91699 12.75L6.90866 11.7583ZM10.592 11.7583L13.8503 8.5L10.592 5.24167L11.5837 4.25L15.8337 8.5L11.5837 12.75L10.592 11.7583Z\" fill=\"#4D39E9\"/>\n</svg>\n";
}));
n();
export { t as default, n as init_aqlBranchIcon };
